<template>
  <div ref="container">
    <a-modal :title="title" :width="1500" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }"
      @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :pagination="pagination" :columns="columns" :loading="loading">
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { accumulategetByNumber } from '@/api/api'
export default {
  name: 'UDIOutlistDialog',
  data () {
    return {
      title: '出库统计详情',
      visible: false,
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      loading: false,
      columns: [
        { title: '退货方', dataIndex: 'inputorName', width: 90, algin: 'center' },
        {
          title: '退货仓库',
          dataIndex: 'depotName',
          width: 140,
        },
        {
          title: '产品码',
          dataIndex: 'code',
          width: 140,
        },
        {
          title: '防伪名称',
          dataIndex: 'pname',
          width: 140,
        },
        {
          title: '产品名称',
          dataIndex: 'name',
          width: 140,
        },
        {
          title: 'UDI名称',
          dataIndex: 'udiName',
          width: 140,
        },
        {
          title: '规格',
          dataIndex: 'standard',
          width: 140,
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          width: 80,
        },

        {
          title: '包装详情',
          dataIndex: 'quantitySpec',
          width: 120,
        },
        // {
        //   title: '电话号码',
        //   dataIndex: 'phonenum',
        // },
        // {
        //   title: '排序',
        //   dataIndex: 'userBlngOrgaDsplSeq',
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
    }
  },
  created () { },
  methods: {
    async add (e, type) {
      this.title = `${type}统计详情`
      this.columns[1].title = `${type}仓库`
      console.log(e, 'e122')
      this.visible = true
      this.pagination.current = 1
      this.loading = true

      const res = await accumulategetByNumber({ number: e })
      console.log(res, 'res')
      if (res.code == 200) {
        this.loading = false
        this.dataSource = res.data
      }
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel () {
      this.close()
    },
    handlePageChange (page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>
<style scoped></style>